import type { NewsArticle } from '@/types/content';

export const newsCategories: string[] = ['全部', '行业动态', '剧集资讯', '演员动态', '幕后花絮', '榜单盘点'];

export const newsList: NewsArticle[] = [
  {
    id: 'n1',
    title: '《长夜将明》口碑持续走高，悬疑叙事为何能再次击中观众',
    summary:
      '开播三周，《长夜将明》在社交平台的讨论量不断攀升。没有流量噱头，全靠扎实的剧本与克制的表演赢得观众，也让国产悬疑剧的创作方向再次成为话题。',
    date: '2026-10-15',
    category: '行业动态',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20rainy%20city%20street%20at%20night%20with%20reflective%20wet%20asphalt%20and%20glowing%20lights%2C%20moody%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-01&orientation=landscape',
    content: [
      '《长夜将明》开播以来，讨论度并没有走"首播即爆"的路线，而是随着剧情推进稳步攀升。这种"后劲型"的走红方式，恰恰说明观众对扎实叙事的需求始终存在。',
      '该剧最被称道的，是它对悬念节奏的控制。编剧没有急于抛出反转，而是把线索均匀地铺在每一集里，让观众在反复回看时仍能发现新的细节。这种尊重观众智力的创作方式，成为口碑发酵的关键。',
      '此外，剧中大量使用环境音与长镜头，把雨夜、霓虹与沉默的对话变成叙事的一部分。有评论认为，这种克制的影像语言，正在成为国产悬疑剧新的风格方向。',
      '对于内容平台而言，《长夜将明》的走红也提供了一个观察样本：当流量红利逐渐退潮，真正能留住观众的，仍然是剧本本身的质量。',
    ],
  },
  {
    id: 'n2',
    title: '《风起长安》大结局播出，权谋群像的收束方式引发热议',
    summary:
      '收官之夜，《风起长安》用一场雪中长镜头完成收束。没有快意恩仇，也没有圆满团圆，这样的结局被观众称为"最像历史的样子"。',
    date: '2026-10-12',
    category: '剧集资讯',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20an%20ancient%20chinese%20city%20wall%20covered%20in%20snow%20at%20dusk%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-02&orientation=landscape',
    content: [
      '《风起长安》在昨晚迎来大结局。与许多同类作品不同，它没有给主要角色安排一个明确的"赢家"，而是把镜头留在了雪落后的长安城与几个渐行渐远的背影上。',
      '编剧在接受采访时表示，这个结局在剧本第一稿时就已经确定。"我们想讲的不是谁赢了，而是所有人都付出了什么。"',
      '观众的反应也相当两极：有人觉得意难平，有人则认为这正是权谋题材应有的克制。相关话题在播出后迅速登上讨论榜前列。',
      '无论评价如何，这部剧对群像人物的塑造，已经被不少从业者视为近年古装题材的重要参考。',
    ],
  },
  {
    id: 'n3',
    title: '《星海纪元》视效特辑发布，硬核科幻如何做到"可信"',
    summary:
      '剧组公布了长达八分钟的视效特辑，从飞船结构到星云渲染，展示了硬核科幻场景背后的制作流程，也让"国产科幻剧能不能拍"这个话题再次被讨论。',
    date: '2026-10-10',
    category: '幕后花絮',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20futuristic%20spaceship%20cockpit%20with%20glowing%20control%20panels%2C%20cool%20sci%20fi%20lighting%2C%20rich%20film%20color%20grading%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-03&orientation=landscape',
    content: [
      '《星海纪元》发布的最新视效特辑，首次完整披露了飞船内部结构与深空场景的制作过程。从概念设计到最终渲染，一个镜头的平均制作周期达到数周。',
      '美术团队表示，为了追求"可信感"，他们刻意避免了过度炫技的光效，而是让所有光源都能在物理上找到来源。这种克制的处理方式，让科幻场景多了一层真实感。',
      '在叙事层面，剧组也做了大量科学顾问工作，力求让每一个设定都能自圆其说。有观众评论："看完特辑再看正片，会发现很多细节原来早有铺垫。"',
      '这部剧的出现，为国产科幻剧提供了新的制作样本，也让更多创作者看到了这一类型的可能性。',
    ],
  },
  {
    id: 'n4',
    title: '十月剧集热度榜出炉：悬疑与现实题材平分秋色',
    summary:
      '最新一期剧集热度榜发布，悬疑题材与现实题材占据了榜单前六中的五席。榜单结构的变化，折射出观众口味的又一次转向。',
    date: '2026-10-08',
    category: '榜单盘点',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20modern%20city%20skyline%20at%20dusk%20with%20warm%20lights%2C%20urban%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-04&orientation=landscape',
    content: [
      '最新一期剧集热度榜正式发布。与上一期相比，最明显的变化是悬疑题材与现实题材的集中上榜，两者合计占据了前六名中的五席。',
      '分析认为，这一变化与近期几部高口碑作品的带动有关。当观众被优质内容教育之后，对题材的偏好也会随之调整。',
      '值得注意的是，本次榜单中"慢热型"剧集的占比明显提高，多部作品的讨论高峰出现在播出中后期，而非首播周。',
      '对于创作者而言，这份榜单传递出的信号相当清晰：稳扎稳打的内容，正在获得越来越长尾的生命力。',
    ],
  },
  {
    id: 'n5',
    title: '《迷雾追凶》师徒线获好评，老戏骨与新人如何互相成就',
    summary:
      '剧中裴云天与谢鹤鸣的师徒关系成为讨论焦点。一老一少的对手戏被观众称为"每一帧都在飙戏"，也让表演传承成为热门话题。',
    date: '2026-10-06',
    category: '演员动态',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20foggy%20forest%20road%20at%20dawn%20with%20soft%20mist%2C%20moody%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-05&orientation=landscape',
    content: [
      '《迷雾追凶》播出过半，裴云天与谢鹤鸣这对师徒成为观众讨论最多的关系线。一个沉默老练，一个热血直率，两人的碰撞几乎撑起了全剧的情绪张力。',
      '有观众总结，这对师徒的动人之处在于"传承感"：老法医把经验一点点交给年轻刑警，年轻人则用自己的方式把老师从过去里拉了出来。',
      '两位演员在采访中都提到，拍摄期间大量对手戏是一遍过，靠的是开拍前长时间的围读与磨合。',
      '这种"互相成就"的表演关系，也让行业再次关注到，好的剧本与合适的搭档，是青年演员成长最好的土壤。',
    ],
  },
  {
    id: 'n6',
    title: '《都市浮生记》引发共鸣：为什么我们总在屏幕里看见自己',
    summary:
      '没有热搜式的冲突，《都市浮生记》却靠着"太真实了"频上讨论榜。合租、加班、涨租……每一个细节都像是从生活里直接搬来的。',
    date: '2026-10-05',
    category: '行业动态',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20cozy%20small%20apartment%20at%20night%20with%20warm%20lamp%20light%2C%20intimate%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-06&orientation=landscape',
    content: [
      '"这剧是不是偷了我的生活？"——这是《都市浮生记》评论区里出现频率最高的一句话。',
      '剧集没有刻意制造戏剧冲突，而是把镜头对准了合租生活里最琐碎的日常：算房租、赶末班车、在天台上吃泡面。恰恰是这些细节，让观众产生了强烈的代入感。',
      '有评论指出，这类"生活流"作品的走红，说明观众对悬浮叙事的耐心正在降低，真实感成为新的核心竞争力。',
      '当然，如何在真实与戏剧性之间取得平衡，仍是这类题材需要长期面对的课题。',
    ],
  },
  {
    id: 'n7',
    title: '多家平台公布2027剧集片单：现实题材与女性叙事成重点',
    summary:
      '在近日举办的行业发布会上，多家平台发布了2027年剧集片单。现实题材与女性视角作品占比明显提升，成为片单中的高频关键词。',
    date: '2026-10-03',
    category: '行业动态',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20an%20empty%20modern%20screening%20room%20with%20soft%20screen%20glow%2C%20cool%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-07&orientation=landscape',
    content: [
      '在近日举办的行业发布会上，多家平台陆续公布了2027年的剧集片单。从整体结构看，现实题材与女性叙事的比重都有明显上升。',
      '一位制片人在分享中提到，市场反馈正在倒逼创作端正视观众的成熟度。"观众不再满足于单一的爽感，他们需要能留下思考的故事。"',
      '片单中也不乏科幻、悬疑等类型的持续投入，显示出平台在题材布局上仍保持多元。',
      '可以预见，未来一年剧集市场的竞争，将从"谁有大制作"逐步转向"谁更懂观众"。',
    ],
  },
  {
    id: 'n8',
    title: '《锦月如歌》服化道被赞"行走的古画"，古装美学卷向细节',
    summary:
      '从发簪到屏风，《锦月如歌》的每一帧都经得起截图。剧组公开的物料显示，仅主角一人的戏服就超过三十套，全部由手工刺绣完成。',
    date: '2026-09-30',
    category: '幕后花絮',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20ancient%20chinese%20silk%20embroidery%20and%20jade%20hairpins%20on%20a%20lacquered%20table%2C%20warm%20soft%20lighting%2C%20rich%20film%20color%20grading%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-08&orientation=landscape',
    content: [
      '《锦月如歌》播出后，最先出圈的并不是剧情，而是服化道。网友戏称，这部剧是"行走的古画"。',
      '剧组公开的幕后物料显示，仅主角一人就有超过三十套戏服，全部采用手工刺绣，单套制作周期可达一个月。道具组也为不同朝代的器物做了详细的考据。',
      '美术指导表示，他们的原则是"可以慢，但不能假"。"观众的眼睛很尖，一个不合理的器物就能让他们出戏。"',
      '这种对细节的执着，正在成为古装题材新的竞争维度。',
    ],
  },
  {
    id: 'n9',
    title: '从"追剧"到"追解析"：二创内容正在改变观众的观看方式',
    summary:
      '越来越多的观众在追剧之外，还会去看剧情解析、人物关系梳理等二创内容。这种"边看边学"的观看方式，正在重塑剧集的传播路径。',
    date: '2026-09-28',
    category: '行业动态',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20person%20watching%20a%20show%20on%20a%20tablet%20in%20a%20dark%20room%20with%20notes%2C%20warm%20screen%20glow%20lighting%2C%20rich%20film%20color%20grading%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-09&orientation=landscape',
    content: [
      '过去，观众看完一集剧，讨论往往停留在"好不好看"。如今，越来越多的人会主动搜索剧情解析、人物关系图甚至时间线梳理。',
      '这种变化的背后，是内容复杂度的提升，也是观众参与意愿的增强。二创内容不再只是"补充说明"，而成为观剧体验的一部分。',
      '对于平台而言，这意味着内容的生命周期被显著拉长：一部剧的热度，可以在播出结束后通过解读内容持续发酵。',
      '有从业者预测，"剧集 + 解析"的组合，将成为未来内容运营的标准配置。',
    ],
  },
  {
    id: 'n10',
    title: '《烟火人间》获赞"最有年味的剧"，家庭题材迎回暖',
    summary:
      '一碗面、一次争吵、一场除夕守岁，《烟火人间》用最日常的画面打动了观众。家庭题材的回归，被认为是内容市场趋向成熟的信号。',
    date: '2026-09-25',
    category: '剧集资讯',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20steaming%20bowl%20of%20noodles%20on%20a%20wooden%20table%20with%20warm%20lights%2C%20cozy%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-10&orientation=landscape',
    content: [
      '《烟火人间》没有大场面，也没有强冲突，却被称为"最有年味的剧"。一碗热气腾腾的面，就是它最有力的表达。',
      '剧中三代人的关系，几乎是无数中国家庭的缩影：父亲的沉默、女儿的倔强、母亲的调和。观众在别人的故事里，看见了自己家的样子。',
      '有评论认为，家庭题材的回暖，是内容市场走向成熟的标志之一。"当观众开始怀念日常，说明他们对生活的理解更深了。"',
      '这份温柔的力量，或许正是快节奏时代里最稀缺的东西。',
    ],
  },
];